import type { Column } from "@tanstack/react-table";
import { X } from "lucide-react";

import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface DataTableFilterTextProps<TData, TValue> {
	column: Column<TData, TValue>;
	placeholder?: string;
	className?: string;
}

function DataTableFilterText<TData, TValue>({
	column,
	placeholder = "Filtrer...",
	className,
}: DataTableFilterTextProps<TData, TValue>) {
	const value = (column.getFilterValue() as string) ?? "";

	return (
		<div className={cn("relative", className)}>
			<Input
				placeholder={placeholder}
				value={value}
				onChange={(e) => column.setFilterValue(e.target.value)}
				className="h-8 w-36 lg:w-48 pr-8"
			/>
			{value && (
				<Button
					variant="ghost"
					size="icon-sm"
					className="absolute right-0 top-0 h-8 w-8"
					onClick={() => column.setFilterValue(undefined)}
				>
					<X className="size-3.5" />
				</Button>
			)}
		</div>
	);
}

export { DataTableFilterText };
